











import { Component, Vue } from "vue-property-decorator";
import { CellGroup, Field, Button, Dialog, Loading, Icon } from "vant";

@Component({
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Loading.name]: Loading,
    [Icon.name]: Icon
  }
})
export default class EmailBind extends Vue {}
